import createIcon from '../../createIcon';

/**
 * @component @name HighQuality
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEg1QzMuODkgNCAzIDQuOSAzIDZWMThDMyAxOS4xIDMuODkgMjAgNSAyMEgxOUMyMC4xIDIwIDIxIDE5LjEgMjEgMThWNkMyMSA0LjkgMjAuMSA0IDE5IDRaTTExIDE1SDkuNVYxM0g3LjVWMTVINlY5SDcuNVYxMS41SDkuNVY5SDExVjE1Wk0xOCAxNEMxOCAxNC41NSAxNy41NSAxNSAxNyAxNUgxNi4yNVYxNi41SDE0Ljc1VjE1SDE0QzEzLjQ1IDE1IDEzIDE0LjU1IDEzIDE0VjEwQzEzIDkuNDUgMTMuNDUgOSAxNCA5SDE3QzE3LjU1IDkgMTggOS40NSAxOCAxMFYxNFpNMTQuNSAxMy41SDE2LjVWMTAuNUgxNC41VjEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HighQuality = createIcon('HighQuality', [
  [
    'path',
    {
      d: 'M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM11 15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11V15ZM18 14C18 14.55 17.55 15 17 15H16.25V16.5H14.75V15H14C13.45 15 13 14.55 13 14V10C13 9.45 13.45 9 14 9H17C17.55 9 18 9.45 18 10V14ZM14.5 13.5H16.5V10.5H14.5V13.5Z',
      key: '18ju0a',
    },
  ],
]);

export default HighQuality;
